import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupHasResumeFilter } from './useSignupHasResumeFilter';

export const SignupHasResumeFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, resumeOptions } = useSignupHasResumeFilter({ setFilters });

  return (
    <Formik
      initialValues={{ signupHasResume: value || resumeOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupHasResume"
          label="Resume"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={resumeOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SignupHasResumeFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

SignupHasResumeFilter.defaultProps = {
  value: null,
};
